const API_DOMAIN = 'wp-blog.guiker.com'
const BLOG_DOMAIN = 'guiker.com/blog'

export const config = {
  baseUrl: `https://${API_DOMAIN}/wp-json/wp/v2`,
  apiDomain: API_DOMAIN,
  blogDomain: BLOG_DOMAIN,
}
